export default __webpack_public_path__ + "static/media/avatar_79.497c013c.png";